<template>
  <div class="page-col">
    <div class="page-main">
      <div class="list-header-premium d-flex flex-column flex-md-row align-items-center justify-content-between gap-3 p-0 mb-3" :class="{'bg-dark border-secondary': isDark}">
        <div class="d-flex align-items-center p-3 flex-shrink-0">
          <div class="header-icon-wrapper mr-3 ml-2" style="background: linear-gradient(135deg, #22c55e 0%, #0f766e 100%);">
            <i class="fa fa-truck text-white"></i>
          </div>
          <div class="header-text-container">
            <h4 class="mb-0 font-weight-bold" :class="isDark ? 'text-white' : 'text-dark'">Ordem de Entrega</h4>
            <p class="text-muted mb-0 small d-none d-lg-block">Cargas formadas a partir das vendas finalizadas do fluxo com conferencia</p>
          </div>
        </div>

        <div class="d-flex align-items-center flex-wrap gap-2 p-3 w-100 w-md-auto justify-content-end">
          <div class="search-pill-responsive d-flex align-items-center bg-light rounded-pill p-1 shadow-xs border mr-2">
            <div class="d-flex align-items-center px-2 mr-2 date-inputs-responsive">
              <cec-input-data ref="edDT1" v-model="dt1" class="mx-1" style="width: 145px" @keydown.enter.native="pesquisar()" />
              <span class="text-muted mx-1">ate</span>
              <cec-input-data ref="edDT2" v-model="dt2" class="mx-1" style="width: 145px" @keydown.enter.native="pesquisar()" />
            </div>
            <b-form-select v-model="status" :options="optionsStatus" class="rounded-pill mr-2" style="width: 160px" />
          <b-button variant="primary" pill class="btn-filtrar-responsive px-4 font-weight-bold shadow-sm text-white" :disabled="isBusy" @click="pesquisar()">
              <i class="fa fa-search mr-1"></i> FILTRAR
            </b-button>
          </div>

          <b-button-group size="sm" class="mr-2">
            <b-button variant="outline-secondary" title="Imprimir" v-b-tooltip.hover @click="exportarHtml">
              <i class="fa fa-print"></i>
            </b-button>
            <b-button variant="outline-success" title="Excel" v-b-tooltip.hover @click="exportarExcel">
              <i class="fa fa-file-excel-o"></i>
            </b-button>
            <b-button variant="outline-info" title="CSV" v-b-tooltip.hover @click="exportarCsv">
              <i class="fa fa-file-text-o"></i>
            </b-button>
            <b-button variant="outline-danger" title="Limpar filtros da tabela" v-b-tooltip.hover @click="onClear">
              <i class="fa fa-filter"></i>
            </b-button>
          </b-button-group>

          <b-button ref="btAdicionar" variant="success" pill class="btn-adicionar-responsive px-4 font-weight-bold shadow-sm" @click.stop.prevent="novo()">
            <i class="fa fa-plus-circle mr-2"></i>
            <span class="d-none d-sm-inline">Nova Ordem</span>
            <span class="d-sm-none">Novo</span>
          </b-button>
        </div>
      </div>

      <b-row class="ml-0 mr-0 p-0" :class="isDark ? 'bg-dark' : 'bg-white'">
        <b-col sm="12" class="p-0">
          <b-table
            ref="tabelaPrincipal"
            class="modern-premium-table"
            show-empty
            empty-text="Informe o filtro para ver as ordens de entrega"
            stacked="sm"
            small
            responsive
            caption-top
            :sticky-header="stickyHeight"
            :head-variant="isDark ? 'dark' : 'light'"
            hover
            :busy.sync="isBusy"
            :items="itensFiltrados"
            :fields="fields"
            :per-page="perPage"
            :current-page="currentPage"
            select-mode="single"
            selectable
            @row-clicked="selecionarLinha"
            @row-dblclicked="edit"
            :tbody-tr-class="rowClassSelecionado"
          >
            <template #head(ID)>
              <SetFilter
                label="ID"
                v-model="filtros.ID"
                :options="opcoes.ID"
                :normalizeFn="normalize"
                :dropdown-variant="isDark ? 'dark' : 'none'"
              />
            </template>

            <template #head(STATUS)>
              <SetFilter
                label="Status"
                v-model="filtros.STATUS"
                :options="opcoes.STATUS"
                :normalizeFn="normalize"
                :dropdown-variant="isDark ? 'dark' : 'none'"
              />
            </template>

            <template #head(DATA)>
              <SetFilter
                label="Data"
                v-model="filtros.DATA"
                :options="opcoes.DATA"
                :normalizeFn="normalize"
                :dropdown-variant="isDark ? 'dark' : 'none'"
              />
            </template>

            <template #head(DATA_CADASTRO)>
              <SetFilter
                label="Cadastro"
                v-model="filtros.DATA_CADASTRO"
                :options="opcoes.DATA_CADASTRO"
                :normalizeFn="normalize"
                :dropdown-variant="isDark ? 'dark' : 'none'"
              />
            </template>

            <template #head(NOME_MOTORISTA)>
              <SetFilter
                label="Motorista"
                v-model="filtros.NOME_MOTORISTA"
                :options="opcoes.NOME_MOTORISTA"
                :normalizeFn="normalize"
                :dropdown-variant="isDark ? 'dark' : 'none'"
              />
            </template>

            <template #head(VENDAS)>
              <SetFilter
                label="Vendas"
                v-model="filtros.VENDAS"
                :options="opcoes.VENDAS"
                :normalizeFn="normalize"
                :dropdown-variant="isDark ? 'dark' : 'none'"
              />
            </template>

            <template #head(QUANT_TOTAL)>
              <SetFilter
                label="Peso"
                v-model="filtros.QUANT_TOTAL"
                :options="opcoes.QUANT_TOTAL"
                :normalizeFn="normalize"
                :dropdown-variant="isDark ? 'dark' : 'none'"
              />
            </template>

            <template #head(VALOR_TOTAL)>
              <SetFilter
                label="Valor"
                v-model="filtros.VALOR_TOTAL"
                :options="opcoes.VALOR_TOTAL"
                :normalizeFn="normalize"
                :dropdown-variant="isDark ? 'dark' : 'none'"
              />
            </template>

            <template #head(USUARIO_CADASTRO)>
              <SetFilter
                label="Usuario"
                v-model="filtros.USUARIO_CADASTRO"
                :options="opcoes.USUARIO_CADASTRO"
                :normalizeFn="normalize"
                :dropdown-variant="isDark ? 'dark' : 'none'"
              />
            </template>

            <template #cell(STATUS)="item">
              <b-badge pill :variant="colorirStatus(item.item.STATUS)">{{ traduzirStatus(item.item.STATUS) }}</b-badge>
            </template>

            <template #cell(DATA)="item">
              {{ formatarData(item.item.DATA) }}
            </template>

            <template #cell(DATA_CADASTRO)="item">
              {{ formatarData(item.item.DATA_CADASTRO) }}
            </template>

            <template #cell(VALOR_TOTAL)="item">
              {{ formatarMoeda(item.item.VALOR_TOTAL) }}
            </template>

            <template #cell(QUANT_TOTAL)="item">
              {{ formatarQuant(item.item.QUANT_TOTAL) }}
            </template>

            <template #cell(actions)="item">
              <b-button-group size="sm">
                <b-button type="button" variant="info" title="Editar" size="sm" v-b-tooltip.hover.left @click.stop.prevent="edit(item.item)">
                  <i class="fa fa-pencil"></i>
                </b-button>
              </b-button-group>
            </template>
          </b-table>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import Tools from '@/tools/tools.js'
import CecInputData from '@/components/Cec/CecInputData.vue'
import SetFilter from '@/components/Cec/SetFilter.vue'
import { createCecTableToolsMixin } from '@/mixins/cecTableTools'
import { printHtmlReport, exportExcelXlsx, exportCsv } from '@/utils/RelatorioHTML'

export default {
  name: 'OrdemEntregaListagem',
  mixins: [createCecTableToolsMixin({
    rowsProp: 'lista',
    tblRef: 'tabelaPrincipal',
    preferVh: 74,
    filters: [
      { key: 'ID', type: 'number', label: 'ID' },
      { key: 'STATUS', type: 'string', label: 'Status', labelMap: { '0': 'Cancelada', '1': 'Aberta', '2': 'Liberada', '4': 'Finalizada' } },
      { key: 'DATA', type: 'date', label: 'Data' },
      { key: 'DATA_CADASTRO', type: 'date', label: 'Cadastro' },
      { key: 'NOME_MOTORISTA', type: 'string', label: 'Motorista' },
      { key: 'VENDAS', type: 'number', label: 'Vendas' },
      { key: 'QUANT_TOTAL', type: 'number', label: 'Peso' },
      { key: 'VALOR_TOTAL', type: 'money', label: 'Valor' },
      { key: 'USUARIO_CADASTRO', type: 'string', label: 'Usuario' }
    ]
  })],
  components: {
    CecInputData,
    SetFilter
  },
  data () {
    return {
      isBusy: false,
      fields: [
        { key: 'ID', label: 'ID', sortable: true, class: 'text-right' },
        { key: 'STATUS', label: 'Status', sortable: true },
        { key: 'DATA', label: 'Data', sortable: true },
        { key: 'DATA_CADASTRO', label: 'Cadastro', sortable: true },
        { key: 'NOME_MOTORISTA', label: 'Motorista', sortable: true },
        { key: 'VENDAS', label: 'Vendas', sortable: true, class: 'text-right' },
        { key: 'QUANT_TOTAL', label: 'Peso', sortable: true, class: 'text-right' },
        { key: 'VALOR_TOTAL', label: 'Valor', sortable: true, class: 'text-right' },
        { key: 'USUARIO_CADASTRO', label: 'Usuario', sortable: true },
        { key: 'actions', label: 'Acoes', class: 'text-right' }
      ],
      optionsStatus: [
        { value: '', text: 'Todas' },
        { value: '1', text: 'Abertas' },
        { value: '2', text: 'Liberadas' },
        { value: '4', text: 'Finalizadas' },
        { value: '0', text: 'Canceladas' }
      ]
    }
  },
  computed: {
    isDark () { return this.$store.getters['tema/IS_DARK'] },
    lista () {
      return this.$store.getters['ordemEntrega/LISTA']
    },
    dt1: {
      get () { return this.$store.getters['ordemEntrega/DT1'] },
      set (value) { this.$store.commit('ordemEntrega/SET_DT1', value) }
    },
    dt2: {
      get () { return this.$store.getters['ordemEntrega/DT2'] },
      set (value) { this.$store.commit('ordemEntrega/SET_DT2', value) }
    },
    status: {
      get () { return this.$store.getters['ordemEntrega/STATUS'] },
      set (value) { this.$store.commit('ordemEntrega/SET_STATUS', value) }
    },
    registroSelecionadoId () {
      return this.$store.getters['ordemEntrega/REGISTRO_SELECIONADO_ID']
    }
  },
  mounted () {
    this.pesquisar()
  },
  methods: {
    exportarHtml () {
      printHtmlReport({
        rows: this.itensFiltrados,
        columns: this.fields.filter(field => field.key !== 'actions'),
        reportTitle: 'Listagem de Ordem de Entrega',
        printedBy: window.localStorage.getItem('login') || '',
        pageSize: 'A4',
        landscape: false
      })
    },
    exportarExcel () {
      exportExcelXlsx({
        rows: this.itensFiltrados,
        columns: this.fields.filter(field => field.key !== 'actions'),
        filename: 'OrdemEntrega.xlsx'
      })
    },
    exportarCsv () {
      exportCsv({
        rows: this.itensFiltrados,
        columns: this.fields.filter(field => field.key !== 'actions'),
        filename: 'OrdemEntrega.csv'
      })
    },
    async pesquisar () {
      this.isBusy = true
      try {
        await this.$store.dispatch('ordemEntrega/GERAR_LISTA')
      } catch (err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err)
      } finally {
        this.isBusy = false
      }
    },
    selecionarLinha (item) {
      this.$store.commit('ordemEntrega/SET_REGISTRO_SELECIONADO_ID', item.ID)
    },
    rowClassSelecionado (item) {
      if (!item) return ''
      return item.ID === this.registroSelecionadoId ? 'table-primary' : ''
    },
    novo () {
      this.$store.commit('ordemEntrega/SET_REGISTRO_SELECIONADO_ID', null)
      this.$router.push('/expedicao/ordementrega/add')
    },
    edit (item) {
      this.$store.commit('ordemEntrega/SET_REGISTRO_SELECIONADO_ID', item.ID)
      this.$router.push(`/expedicao/ordementrega/edit/${item.ID}`)
    },
    traduzirStatus (status) {
      if (status === '0') return 'CANCELADA'
      if (status === '1') return 'ABERTA'
      if (status === '2') return 'LIBERADA'
      if (status === '4') return 'FINALIZADA'
      return 'INDEF'
    },
    colorirStatus (status) {
      if (status === '0') return 'danger'
      if (status === '1') return 'warning'
      if (status === '2') return 'success'
      if (status === '4') return 'info'
      return 'secondary'
    },
    formatarData (valor) {
      return valor ? moment(String(valor)).format('DD/MM/YYYY') : ''
    },
    formatarQuant (valor) {
      return Number(valor || 0).toLocaleString('pt-BR', { minimumFractionDigits: 3, maximumFractionDigits: 3 })
    },
    formatarMoeda (valor) {
      return Number(valor || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/expedicao/ordementrega/OrdemEntregaListagem.vue